import {PLATFORM_ID, Injectable, Inject  } from '@angular/core';
import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { style } from '@angular/animations';

@Injectable({
  providedIn: 'root'
})
export class CssInjectorService {
  private styleElements: Array<HTMLStyleElement> = [];
  
  constructor(
    private http: HttpClient,
    @Inject(PLATFORM_ID) private platformId: any,
    @Inject(DOCUMENT) private document: Document
  ) { }



  injectCSS(entryLocation: string, cssString: string): void {
    
    if(cssString) {
      if (isPlatformBrowser(this.platformId)) {
        this.removeExistingCSS(entryLocation);
        
        var styleElement: HTMLStyleElement;
  
        styleElement = this.document.createElement('style');
        styleElement.type = 'text/css';
        styleElement.id = 'style-' + entryLocation;
        styleElement.textContent = cssString;
  
        try {

          this.document.head.appendChild(styleElement);

          this.styleElements.push(styleElement);
        } catch (error) {
          console.error(error)
        }
  
  
      }
    } else {
      this.removeExistingCSS(entryLocation)
    }
  }


  removeExistingCSS(entryLocation: string): void {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }

    const styleId = 'style-' + entryLocation;
    
    const existingStyle = this.document.getElementById(styleId);
    if (existingStyle && existingStyle.parentNode) {
      existingStyle.parentNode.removeChild(existingStyle);
    }

    this.styleElements = this.styleElements.filter((style: HTMLStyleElement) => {
      if (!this.document.contains(style)) {
        return false;
      }
      
      if (style.id === styleId) {
        if (style.parentNode) {
          style.parentNode.removeChild(style);
        }
        return false;
      }    
      return true;
    });
  }

  validateCSS(css: string): boolean {
    const basicCSSPattern = /([.#][a-zA-Z_-][a-zA-Z0-9_-]*\s*\{[^{}]*:[^{}]*;\s*\})/;
    return basicCSSPattern.test(css);
  }  

}
